import { render } from "./BirthDayComponent.vue?vue&type=template&id=b9ed69a0&scoped=true"
import script from "./BirthDayComponent.vue?vue&type=script&lang=js"
export * from "./BirthDayComponent.vue?vue&type=script&lang=js"

import "./BirthDayComponent.vue?vue&type=style&index=0&id=b9ed69a0&lang=scss&scoped=true"

import exportComponent from "/var/www/recruitment-form-front-end-master/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9ed69a0"]])

export default __exports__